import { storageGet, storageSave } from './Storage';

const SAVE_KEY = 'fp_pre_request';

export const saveBookingRequest = (data) => storageSave(SAVE_KEY, data, true);
export const getSavedBookingRequest = () => storageGet(SAVE_KEY, true);
export const clearSavedBookingRequest = () => storageSave(SAVE_KEY, null, true);